import React, { useContext, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { func } from 'prop-types';

import useStyles from 'hooks/useStyles';
import useGetFreeTrialInfo from 'hooks/useGetFreeTrialInfo';

import CourseContext from 'routes/course/components/CourseContext';
import BaseModal from 'components/BaseModal';
import ApplicationContext from 'components/ApplicationContext';
import Button from 'components/Button';

import HighlightItem from './components/HighlightItem';

import styles from './PayWallModal.scss';
import { useDispatch } from 'react-redux';
import { openSocialWidget } from 'reduxModules/socialWidget/action';

function PayWallModal({ onPurchaseButtonClick }) {
  useStyles(styles);

  const dispatch = useDispatch();
  const { t } = useTranslation(['course']);
  const {
    screenWidth: { isMobile },
  } = useContext(ApplicationContext);

  const {
    id,
    title,
    pictureUrl,
    highlightList,
    isOpenPaywallModal,
    closePaywallModal,
    lessonsAmount,
    lessonMeta: { durationTotal },
    checkoutCollection,
  } = useContext(CourseContext);

  const {
    isAllowFreeTrialRegion,
    buttonText,
    handleTriggerFreeTrialLink,
  } = useGetFreeTrialInfo({
    type: 'course',
    id,
    name: title,
    section: 'lesson_page_paywall',
  });

  const { displayPrice: { sellingPrice } = {} } = checkoutCollection;

  const { hours, minutes } = durationTotal;

  const handleContactUsButtonClick = () => {
    closePaywallModal();

    if (isAllowFreeTrialRegion) {
      handleTriggerFreeTrialLink();
    } else {
      dispatch(openSocialWidget());
    }
  };

  if (!isOpenPaywallModal || !sellingPrice) return null;

  return (
    <BaseModal
      closable
      title={t('payWall.title')}
      buttons={
        <Fragment>
          <Button
            type="dark"
            className={styles.contactUs}
            onClick={handleContactUsButtonClick}
            ghost
          >
            {isAllowFreeTrialRegion ? buttonText : t('payWall.cta0')}
          </Button>
          <Button onClick={() => onPurchaseButtonClick('video')}>
            {t('payWall.cta1', { price: sellingPrice })}
          </Button>
        </Fragment>
      }
      onClose={closePaywallModal}
    >
      <div className={styles.root}>
        <img className={styles.banner} src={pictureUrl} alt={title} />
        <h5 className={styles.infoTitle}>
          {t('payWall.courseTitle')}
          {` ${title}`}
        </h5>
        <div className={styles.infoContent}>
          {t('payWall.description', {
            lesson_plural: lessonsAmount,
            time: t('videoplayer.time', { hours, minutes }),
          })}
        </div>
        {!isMobile && (
          <div className={styles.aboutThis}>
            <div className={styles.aboutThisTitle}>{t('payWall.about')}</div>
            <ul className={styles.highlightList}>
              {highlightList.map(
                ({ iconUrl, title: highlightTitle }, index) => {
                  return (
                    <HighlightItem
                      className={styles.highlightItem}
                      // eslint-disable-next-line react/no-array-index-key
                      key={`${index}-${highlightTitle}`}
                      iconUrl={iconUrl}
                      content={highlightTitle}
                    />
                  );
                },
              )}
            </ul>
          </div>
        )}
      </div>
    </BaseModal>
  );
}

PayWallModal.propTypes = {
  onPurchaseButtonClick: func.isRequired,
};

export default PayWallModal;
